module.exports = __webpack_public_path__ + "static/media/img_ziliao.0c18ca43.jpg";